import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import {
	cancelOrderThunk,
	gameInvogceHTMLThunk,
	getMobileOrdersThunk,
	getOrdersThunk,
	getSpecificOrderDetailsThunk,
	refundOrderThunk,
	replacementOrderThunk,
} from './ordersThunk'

const initialState = {
	ordersData: [],
	ordersCount: 0,
	mobileOrdersData: [],
	mobileOrdersCount: 0,
	specificOrderDetails: null,
	issueResponse: 0,
}

export const getOrders = createAsyncThunk('user/getOrders', getOrdersThunk)
export const getMobileOrders = createAsyncThunk('user/getMobileOrders', getMobileOrdersThunk)
export const cancelOrder = createAsyncThunk('user/cancelOrder', cancelOrderThunk)
export const refundOrder = createAsyncThunk('user/refundOrder', refundOrderThunk)
export const replacementOrder = createAsyncThunk('user/replacementOrder', replacementOrderThunk)
export const downloadGameInvogceHTML = createAsyncThunk('user/downloadGameInvogceHTML', gameInvogceHTMLThunk)
export const getSpecificOrderDetails = createAsyncThunk('user/getSpecificOrderDetails', getSpecificOrderDetailsThunk)

export const orderSlice = createSlice({
	name: 'orders',
	initialState,
	reducers: {
		// setUserProfileData: (state, action) => {
		// 	state.profileData = action.payload
		// },
	},
	extraReducers: (builder) => {
		builder.addCase(getOrders.fulfilled, (state, action) => {
			state.ordersData = action?.payload?.data?.data
			state.ordersCount = action?.payload?.data?.total
		})
		builder.addCase(getMobileOrders.fulfilled, (state, action) => {
			state.mobileOrdersData = action?.payload?.data?.data
			state.mobileOrdersCount = action?.payload?.data?.total
		})
		builder.addCase(cancelOrder.fulfilled, (state, action) => {
			state.issueResponse = action?.payload?.data?.status
		})
		builder.addCase(refundOrder.fulfilled, (state, action) => {
			state.issueResponse = action?.payload?.data?.status
		})
		builder.addCase(replacementOrder.fulfilled, (state, action) => {
			state.issueResponse = action?.payload?.data?.status
		})
		builder.addCase(getSpecificOrderDetails.fulfilled, (state, action) => {
			state.specificOrderDetails = action?.payload?.data?.data
		})
	},
})
// export const {} = teamsSlice.actions
export default orderSlice.reducer
